export const getJsonData = (selector: string) => {
  const scriptEl = document.querySelector(selector)

  if (!scriptEl) {
    return false
  }

  // Using `any`, because we don't know JSON object structure.
  // @ts-ignore
  return JSON.parse(scriptEl.textContent)
}
